import _css from "@emotion/css";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React, { PureComponent } from 'react';
import { styleReducerNoOp, withContentTheme } from '../../../theme';

var isString = function isString(x) {
  return typeof x === 'string';
};

var ComponentSwitch = function ComponentSwitch(_ref) {
  var as = _ref.as,
      dataset = _ref.dataset,
      draggableProps = _ref.draggableProps,
      innerRef = _ref.innerRef,
      rest = _objectWithoutProperties(_ref, ["as", "dataset", "draggableProps", "innerRef"]);

  var isElement = isString(as);
  var props = isElement ? _objectSpread({}, dataset, rest) : _objectSpread({
    innerRef: innerRef,
    dataset: dataset,
    draggableProps: draggableProps
  }, rest); // only pass the actual `ref` to an element, it's the responsibility of the
  // component author to use `innerRef` where applicable

  var ref = isElement ? innerRef : null;
  var ElementOrComponent = as;
  return ___EmotionJSX(ElementOrComponent, _extends({
    ref: ref
  }, draggableProps, props));
};

var getItemComponentProps = function getItemComponentProps(props) {
  var isActive = props.isActive,
      isHover = props.isHover,
      isSelected = props.isSelected,
      isFocused = props.isFocused,
      isDragging = props.isDragging,
      theme = props.theme,
      componentProps = _objectWithoutProperties(props, ["isActive", "isHover", "isSelected", "isFocused", "isDragging", "theme"]);

  return componentProps;
};

var ItemPrimitive =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ItemPrimitive, _PureComponent);

  function ItemPrimitive() {
    _classCallCheck(this, ItemPrimitive);

    return _possibleConstructorReturn(this, _getPrototypeOf(ItemPrimitive).apply(this, arguments));
  }

  _createClass(ItemPrimitive, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          After = _this$props.after,
          Before = _this$props.before,
          CustomComponent = _this$props.component,
          dataset = _this$props.dataset,
          draggableProps = _this$props.draggableProps,
          href = _this$props.href,
          innerRef = _this$props.innerRef,
          isActive = _this$props.isActive,
          isDragging = _this$props.isDragging,
          isHover = _this$props.isHover,
          isSelected = _this$props.isSelected,
          onClick = _this$props.onClick,
          isFocused = _this$props.isFocused,
          spacing = _this$props.spacing,
          styleReducer = _this$props.styles,
          subText = _this$props.subText,
          target = _this$props.target,
          text = _this$props.text,
          theme = _this$props.theme;
      var mode = theme.mode,
          context = theme.context;
      var presentationProps = {
        isActive: isActive,
        isDragging: isDragging,
        isHover: isHover,
        isSelected: isSelected,
        isFocused: isFocused,
        spacing: spacing
      };
      var defaultStyles = mode.item(presentationProps)[context];
      var styles = styleReducer(defaultStyles, presentationProps, theme); // base element switch

      var itemComponent = 'div';
      var itemProps = {
        draggableProps: draggableProps,
        innerRef: innerRef,
        dataset: dataset
      };

      if (CustomComponent) {
        itemComponent = CustomComponent;
        itemProps = getItemComponentProps(this.props);
      } else if (href) {
        itemComponent = 'a';
        itemProps = {
          dataset: dataset,
          href: href,
          onClick: onClick,
          target: target,
          draggableProps: draggableProps,
          innerRef: innerRef
        };
      } else if (onClick) {
        itemComponent = 'button';
        itemProps = {
          dataset: dataset,
          onClick: onClick,
          draggableProps: draggableProps,
          innerRef: innerRef
        };
      }

      return ___EmotionJSX(ComponentSwitch, _extends({
        as: itemComponent,
        css:
        /*#__PURE__*/
        _css({
          '&&': styles.itemBase
        }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
      }, itemProps), !!Before && ___EmotionJSX("div", {
        css: styles.beforeWrapper
      }, ___EmotionJSX(Before, presentationProps)), ___EmotionJSX("div", {
        css: styles.contentWrapper
      }, ___EmotionJSX("div", {
        css: styles.textWrapper
      }, text), !!subText && ___EmotionJSX("div", {
        css: styles.subTextWrapper
      }, subText)), !!After && ___EmotionJSX("div", {
        css: styles.afterWrapper
      }, ___EmotionJSX(After, presentationProps)));
    }
  }]);

  return ItemPrimitive;
}(PureComponent);

_defineProperty(ItemPrimitive, "defaultProps", {
  dataset: {
    'data-test-id': 'NavigationItem'
  },
  isActive: false,
  isDragging: false,
  isHover: false,
  isSelected: false,
  isFocused: false,
  spacing: 'default',
  styles: styleReducerNoOp,
  text: ''
});

export { ItemPrimitive as ItemPrimitiveBase };
export default withContentTheme(ItemPrimitive);